import { render, staticRenderFns } from "./ModalConfirmRegularDelete.vue?vue&type=template&id=2c921f1c&scoped=true&"
import script from "./ModalConfirmRegularDelete.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmRegularDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c921f1c",
  null
  
)

export default component.exports